module.exports = __webpack_public_path__ + "static/media/sso-icon.e60c6c39.png";